// extracted by mini-css-extract-plugin
export default {"root":"MainBar-root-3c0f9983522f131b1e7c7069758c29c8","container":"MainBar-container-955ff3431aca3324cb4d84950a617b85","title":"MainBar-title-1cfed3ba21b7cb7c6a6e95e794491583"};